import { docReady } from './utils';

const ctaInit = () => {
  const form = document.getElementById('formCta');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const nome = document.getElementById('ctaNome')?.value?.trim() || '';
    const email = document.getElementById('ctaEmail')?.value?.trim() || '';
    if (!nome || !email) {
      console.warn('Preencha nome e e-mail.');
      return;
    }
    const msg = `Olá, equipe I9! Sou ${nome} e quero um orçamento. Meu e-mail: ${email}`;
    const phone = '5519997896759';
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank');
  });

  // Pré-preencher e-mail do topo
  const topEmail = document.getElementById('ctaEmailTop');
  if (topEmail) {
    topEmail.addEventListener('input', (e) => {
      const val = e.target.value;
      const target = document.getElementById('ctaEmail');
      if (target) target.value = val;
    });
  }
};

docReady(ctaInit);
